import { render, staticRenderFns } from "./Insurance.vue?vue&type=template&id=1cc82a7a&scoped=true&"
import script from "./Insurance.ts?vue&type=script&lang=ts&"
export * from "./Insurance.ts?vue&type=script&lang=ts&"
import style0 from "./Insurance.vue?vue&type=style&index=0&id=1cc82a7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc82a7a",
  null
  
)

export default component.exports